export const DIETARY_OPTIONS = [
  'None',
  'Vegetarian',
  'Vegan',
  'Gluten-free',
  'Halal',
  'Kosher',
  'Other',
];

export const WEBSITE_SECTION_ORDER = [
  'Hero',
  'Our Story',
  'Wedding Details',
  'Optional Schedule',
  'Travel & Info',
  'RSVP',
  'Photo Upload CTA',
  'Footer',
];

export const WEDDING_TEMPLATES = [
  {
    key: 'romantic-classic',
    name: 'Romantic Classic',
    heroLayout: 'split',
    fontClass: 'font-serif',
    variants: [
      { key: 'blush-stone', name: 'Blush Stone', page: 'bg-rose-50 text-stone-900', surface: 'bg-white border-rose-100', accent: 'bg-rose-200 text-rose-900', button: 'bg-rose-700 hover:bg-rose-700/90 text-white' },
      { key: 'sage-ivory', name: 'Sage Ivory', page: 'bg-[#f7f4ee] text-[#2f3a34]', surface: 'bg-white border-[#d7ddd7]', accent: 'bg-[#8ca192] text-white', button: 'bg-[#2f3a34] hover:bg-[#2f3a34]/90 text-white' },
      { key: 'dusty-blue', name: 'Dusty Blue', page: 'bg-sky-50 text-slate-900', surface: 'bg-white border-sky-100', accent: 'bg-sky-200 text-sky-900', button: 'bg-slate-700 hover:bg-slate-700/90 text-white' },
    ],
  },
  {
    key: 'minimal-modern',
    name: 'Minimal Modern',
    heroLayout: 'centered',
    fontClass: 'font-sans',
    variants: [
      { key: 'mono', name: 'Monochrome', page: 'bg-white text-black', surface: 'bg-stone-50 border-stone-200', accent: 'bg-black text-white', button: 'bg-black hover:bg-black/90 text-white' },
      { key: 'warm-neutral', name: 'Warm Neutral', page: 'bg-[#eae8e3] text-[#1a1a1a]', surface: 'bg-white border-[#d8d2c8]', accent: 'bg-[#d35245] text-white', button: 'bg-[#1a1a1a] hover:bg-[#1a1a1a]/90 text-white' },
      { key: 'slate', name: 'Slate', page: 'bg-slate-100 text-slate-900', surface: 'bg-white border-slate-200', accent: 'bg-slate-700 text-white', button: 'bg-slate-700 hover:bg-slate-700/90 text-white' },
    ],
  },
  {
    key: 'botanical',
    name: 'Botanical',
    heroLayout: 'full-image',
    fontClass: 'font-serif',
    variants: [
      { key: 'forest', name: 'Forest', page: 'bg-[#1c2c22] text-[#ebe6e0]', surface: 'bg-[#25372b] border-[#35503f]', accent: 'bg-[#3d5245] text-white', button: 'bg-[#a3b99f] hover:bg-[#a3b99f]/90 text-[#1c2c22]' },
      { key: 'moss', name: 'Moss', page: 'bg-[#e9ede7] text-[#2d3a31]', surface: 'bg-white border-[#ced9d0]', accent: 'bg-[#a3b1a6] text-[#1f2c22]', button: 'bg-[#2d3a31] hover:bg-[#2d3a31]/90 text-white' },
      { key: 'terracotta', name: 'Terracotta', page: 'bg-[#f3ebe5] text-[#5c3a21]', surface: 'bg-white border-[#e7d3c5]', accent: 'bg-[#d89371] text-[#4b2f1b]', button: 'bg-[#5c3a21] hover:bg-[#5c3a21]/90 text-white' },
      { key: 'linen', name: 'Linen', page: 'bg-[#faf9f6] text-[#3b423a]', surface: 'bg-white border-[#dbe0d9]', accent: 'bg-[#c4cdc5] text-[#2f3a33]', button: 'bg-[#3b423a] hover:bg-[#3b423a]/90 text-white' },
    ],
  },
  {
    key: 'luxury-editorial',
    name: 'Luxury Editorial',
    heroLayout: 'asymmetric',
    fontClass: 'font-serif',
    variants: [
      { key: 'onyx', name: 'Onyx', page: 'bg-zinc-950 text-zinc-100', surface: 'bg-zinc-900 border-zinc-700', accent: 'bg-amber-300 text-zinc-950', button: 'bg-amber-300 hover:bg-amber-300/90 text-zinc-950' },
      { key: 'parchment', name: 'Parchment', page: 'bg-[#f4f1eb] text-[#1c1c1c]', surface: 'bg-white border-[#d7ccbb]', accent: 'bg-[#c2b7a3] text-[#2f2417]', button: 'bg-[#1c1c1c] hover:bg-[#1c1c1c]/90 text-white' },
      { key: 'wine', name: 'Wine', page: 'bg-[#2e151b] text-[#f3ece4]', surface: 'bg-[#45222a] border-[#7e3d4d]', accent: 'bg-[#7e3d4d] text-white', button: 'bg-[#f3ece4] hover:bg-[#f3ece4]/90 text-[#2e151b]' },
    ],
  },
  {
    key: 'coastal',
    name: 'Coastal',
    heroLayout: 'full-image',
    fontClass: 'font-serif',
    variants: [
      { key: 'ocean-mist', name: 'Ocean Mist', page: 'bg-[#f3f7f8] text-[#122b3e]', surface: 'bg-white border-[#c8d8de]', accent: 'bg-[#2c5c7a] text-white', button: 'bg-[#122b3e] hover:bg-[#122b3e]/90 text-white' },
      { key: 'harbor-blue', name: 'Harbor Blue', page: 'bg-[#eaf1f7] text-[#1d3650]', surface: 'bg-white border-[#bfd0df]', accent: 'bg-[#6d8ca8] text-white', button: 'bg-[#1d3650] hover:bg-[#1d3650]/90 text-white' },
      { key: 'sand-sea', name: 'Sand & Sea', page: 'bg-[#f8f4ee] text-[#27384a]', surface: 'bg-white border-[#d9cec2]', accent: 'bg-[#b7c4cf] text-[#1b2a36]', button: 'bg-[#27384a] hover:bg-[#27384a]/90 text-white' },
    ],
  },
  {
    key: 'floral',
    name: 'Floral',
    heroLayout: 'centered',
    fontClass: 'font-serif',
    variants: [
      { key: 'garden-ivory', name: 'Garden Ivory', page: 'bg-[#f0f5f1] text-[#2b3a26]', surface: 'bg-white border-[#d3ddd3]', accent: 'bg-[#a8bca1] text-[#23301f]', button: 'bg-[#2b3a26] hover:bg-[#2b3a26]/90 text-white' },
      { key: 'blossom-pearl', name: 'Blossom Pearl', page: 'bg-[#faf7f8] text-[#3a2e33]', surface: 'bg-white border-[#e4d2d8]', accent: 'bg-[#d9bcc7] text-[#3a2e33]', button: 'bg-[#3a2e33] hover:bg-[#3a2e33]/90 text-white' },
      { key: 'olive-bloom', name: 'Olive Bloom', page: 'bg-[#eef3ea] text-[#2f3b2a]', surface: 'bg-white border-[#ced7c7]', accent: 'bg-[#a7b48d] text-[#222b1f]', button: 'bg-[#2f3b2a] hover:bg-[#2f3b2a]/90 text-white' },
    ],
  },
  {
    key: 'modern',
    name: 'Modern',
    heroLayout: 'vertical-split',
    fontClass: 'font-sans',
    variants: [
      { key: 'midnight', name: 'Midnight', page: 'bg-[#0f172a] text-slate-100', surface: 'bg-[#1e293b] border-[#334155]', accent: 'bg-[#334155] text-white', button: 'bg-slate-100 hover:bg-slate-100/90 text-[#0f172a]' },
      { key: 'dove-grey', name: 'Dove Grey', page: 'bg-[#f1f5f9] text-[#0f172a]', surface: 'bg-white border-[#cbd5e1]', accent: 'bg-[#cbd5e1] text-[#0f172a]', button: 'bg-[#0f172a] hover:bg-[#0f172a]/90 text-white' },
      { key: 'pure-white', name: 'Pure White', page: 'bg-white text-black', surface: 'bg-stone-50 border-stone-200', accent: 'bg-stone-200 text-stone-900', button: 'bg-black hover:bg-black/90 text-white' },
    ],
  },
  {
    key: 'classic',
    name: 'Classic',
    heroLayout: 'centered',
    fontClass: 'font-serif',
    variants: [
      { key: 'navy-pearl', name: 'Navy Pearl', page: 'bg-[#fcfbf9] text-[#0b1d3a]', surface: 'bg-white border-[#d8cfbf]', accent: 'bg-[#e8dcc4] text-[#3f2f17]', button: 'bg-[#0b1d3a] hover:bg-[#0b1d3a]/90 text-white' },
      { key: 'heritage-cream', name: 'Heritage Cream', page: 'bg-[#f8f3ec] text-[#2b3540]', surface: 'bg-white border-[#e0d1bd]', accent: 'bg-[#cdba9e] text-[#2f2314]', button: 'bg-[#2b3540] hover:bg-[#2b3540]/90 text-white' },
      { key: 'soft-taupe', name: 'Soft Taupe', page: 'bg-[#f5f1ea] text-[#3a2f26]', surface: 'bg-white border-[#e2d8ca]', accent: 'bg-[#d6c7b3] text-[#372a1f]', button: 'bg-[#3a2f26] hover:bg-[#3a2f26]/90 text-white' },
    ],
  },
  {
    key: 'rustic',
    name: 'Rustic',
    heroLayout: 'full-image',
    fontClass: 'font-serif',
    variants: [
      { key: 'cedar', name: 'Cedar', page: 'bg-[#f0ece3] text-[#2c2a28]', surface: 'bg-[#f8f4ec] border-[#ddcfbd]', accent: 'bg-[#8b5e3c] text-white', button: 'bg-[#2c2a28] hover:bg-[#2c2a28]/90 text-white' },
      { key: 'forest-rustic', name: 'Forest Rustic', page: 'bg-[#ece8df] text-[#2f4f4f]', surface: 'bg-white border-[#cfd0bf]', accent: 'bg-[#a37a57] text-white', button: 'bg-[#2f4f4f] hover:bg-[#2f4f4f]/90 text-white' },
      { key: 'barn-light', name: 'Barn Light', page: 'bg-[#f7f2ea] text-[#3b3127]', surface: 'bg-white border-[#e0d4c7]', accent: 'bg-[#b6926e] text-white', button: 'bg-[#3b3127] hover:bg-[#3b3127]/90 text-white' },
    ],
  },
  {
    key: 'dark-elegant',
    name: 'Dark Elegant',
    heroLayout: 'glass-overlay',
    fontClass: 'font-serif',
    variants: [
      { key: 'noir-gold', name: 'Noir Gold', page: 'bg-[#0d0f12] text-[#f4f4f5]', surface: 'bg-[#1a1d24] border-[#2c313c]', accent: 'bg-[#d4af37] text-[#1a1d24]', button: 'bg-[#d4af37] hover:bg-[#d4af37]/90 text-[#1a1d24]' },
      { key: 'deep-emerald', name: 'Deep Emerald', page: 'bg-[#062017] text-[#ecfdf5]', surface: 'bg-[#0b3023] border-[#0f5138]', accent: 'bg-[#059669] text-white', button: 'bg-[#059669] hover:bg-[#059669]/90 text-white' },
      { key: 'plum-night', name: 'Plum Night', page: 'bg-[#2e1025] text-[#fdf2f8]', surface: 'bg-[#421937] border-[#693458]', accent: 'bg-[#be185d] text-white', button: 'bg-[#fdf2f8] hover:bg-[#fdf2f8]/90 text-[#2e1025]' },
      { key: 'navy-velvet', name: 'Navy Velvet', page: 'bg-[#0a101d] text-[#e0e7ff]', surface: 'bg-[#141d2e] border-[#243252]', accent: 'bg-[#4f46e5] text-white', button: 'bg-[#4f46e5] hover:bg-[#4f46e5]/90 text-white' },
    ],
  },
];

export const getTemplateByKey = (templateKey) =>
  WEDDING_TEMPLATES.find((template) => template.key === templateKey) || WEDDING_TEMPLATES[0];

export const getVariantByKey = (template, variantKey) =>
  template.variants.find((variant) => variant.key === variantKey) || template.variants[0];
